import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';

import Modal, { CONTENT_SIZE } from '@ott/modal';
import { DropdownOverlay } from '@ott/dropdown-next-deprecated';
import MobileHeader from './blocks/MobileHeader/MobileHeader';
import OptionRenderer from './blocks/OptionRenderer/OptionRenderer';

import cls from 'classnames';
import styles from './AutocompleteOverlay.scss';

export default function AutocompleteOverlay(props) {
  const { className, isMobileLayout, triggerProps, closeOverlay } = props;

  const overlayNode = (
    <DropdownOverlay
      {...props}
      className={cls(styles.dropdownOverlay, className)}
      isShowEmpty={isMobileLayout}
      OptionRenderer={OptionRenderer}
    />
  );

  if (!isMobileLayout) {
    return overlayNode;
  }

  const mobileOverlayRef = useRef(null);
  const wrapperRef = useRef(null);

  // если на мобилке переключаемся по стрелкам '⌃', '⌄' между элементами,
  // то нужно закрывать Overlay
  const onBlur = useCallback(
    (event) => {
      const { current: domNode } = mobileOverlayRef;
      let { relatedTarget } = event;

      if (relatedTarget && domNode && !domNode.contains(relatedTarget)) {
        closeOverlay({ revertChanges: true });
      }
    },
    [mobileOverlayRef, closeOverlay]
  );

  const onClose = useCallback(() => {
    closeOverlay({ revertChanges: true });
  }, [closeOverlay]);

  return (
    <Modal
      isOpen={true}
      contentOptions={{
        title: triggerProps.title,
        size: CONTENT_SIZE.WIDE,
        hasFixedHeaderAndFooter: true,
        headerContentNode: (
          <MobileHeader {...triggerProps} closeOverlay={closeOverlay} isMobileInput={true} />
        ),
        childrenClassNames: {
          header: styles.header,
          closer: styles.closer,
        },
      }}
      fullScreenOnMobile={true}
      fullScreenBreakpoint={1000}
      onClose={onClose}
    >
      <div className={styles.autocompleteOverlay} ref={mobileOverlayRef} onBlur={onBlur}>
        <div data-allow-touch-move={true} ref={wrapperRef}>
          {React.cloneElement(overlayNode, {
            className: styles.mobileOverlay,
            overlayRef: null,
            portalContainerRef: wrapperRef,
          })}
        </div>
      </div>
    </Modal>
  );
}

export const checkOptionsEquality = (a, b) => (a && a.id) === (b && b.id);

AutocompleteOverlay.defaultProps = {
  ...DropdownOverlay.defaultProps,
  checkEquality: checkOptionsEquality,
};

AutocompleteOverlay.propTypes = {
  ...DropdownOverlay.propTypes,
  // eslint-disable-next-line react/forbid-prop-types
  triggerProps: PropTypes.object.isRequired,
  OptionIconRenderer: PropTypes.func,
  checkEquality: PropTypes.func,
};
